import React, { useCallback, useLayoutEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';
import Indicator from 'design-system/Indicator';
import IconFilterBold from 'design-system/icons/IconFilterBold';
import { SCROLL_INDICATOR_INSETS, rem } from 'design-system/values';
import { AppView, withAnimatedNavigationHeader } from 'design-system';
import ReanimatedStackHeader from 'design-system/hoc/ReanimatedStackHeader';
import NavigationHeaderRightIconButton from 'design-system/NavigationHeaderRightIconButton';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { extractKeyFromKey } from 'utils/flatListHelpers';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import Header from '../components/CategoryHeaderComponent';
import StockSearchResult from '../components/StockSearchResult';
import { FilterAssetsModal } from '../components/FilterAssetsModal';
import useCategoryFilterDetails from '../hooks/useCategoryFilterDetails';
import { AssetFilterCategory } from '../types';
import SetupInvestmentAccountButton from '../components/SetupInvestmentAccountButton';
import { selectShowSetupInvestAccountInInvestScreens } from '../reducers/selectors';
import FundPickerFloatingBar from '../components/FundPickerFloatingBar';
import useFundPickerStore from '../hooks/useFundPickerStore';
import { isWeb } from '../../../constants';
const HeaderRight = ({ openFilterModal }) => {
    const colors = useColors();
    const onFilterPress = () => {
        openFilterModal?.();
    };
    return (<NavigationHeaderRightIconButton onPress={onFilterPress}>
      <IconFilterBold color={colors.text.primary}/>
    </NavigationHeaderRightIconButton>);
};
const CategoryFilterDetailsScreen = withAnimatedNavigationHeader(({ route, navigation, scrollY, scrollHandler }) => {
    const id = route.params?.id;
    const Icon = route.params?.Icon;
    const name = route.params?.title;
    const filterType = route.params?.filterType;
    const description = route.params?.description;
    const showSetupInvestAccountInInvestScreens = useAppSelector(selectShowSetupInvestAccountInInvestScreens);
    const { active: fundPickerMode } = useFundPickerStore();
    const [state, setState] = useState({
        selectedFilter: AssetFilterCategory.NAME,
    });
    const [searchResults, loading, count, search] = useCategoryFilterDetails(id, filterType, state.selectedFilter);
    useLayoutEffect(() => {
        const headerTitleWidth = name ? rem(200) : '100%';
        navigation.setOptions({
            headerTitle: () => <ReanimatedStackHeader title={name} scrollY={scrollY} width={headerTitleWidth}/>,
        });
    }, [name, scrollY]);
    useLayoutEffect(() => {
        const onSelectFilter = (filter) => {
            setState((oldState) => ({
                ...oldState,
                selectedFilter: filter,
            }));
        };
        const openFilterModal = () => {
            FilterAssetsModal.show(state.selectedFilter, onSelectFilter);
        };
        navigation.setOptions({
            headerRight: () => <HeaderRight openFilterModal={openFilterModal}/>,
        });
    }, [state.selectedFilter]);
    const renderItem = useCallback(({ item }) => <StockSearchResult data={item}/>, []);
    const onEndReached = useCallback(() => {
        search();
    }, [search]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    return (<AppView withFrame={false}>
        <Animated.FlatList data={searchResults} renderItem={renderItem} initialNumToRender={20} scrollEventThrottle={1} onScroll={scrollHandler} onEndReached={onEndReached} onEndReachedThreshold={0.8} keyboardDismissMode="on-drag" keyExtractor={extractKeyFromKey('symbol')} showsVerticalScrollIndicator scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={contentContainerStyle} ListHeaderComponent={<Header name={name} total={count} Icon={Icon} description={description}/>}/>
        {loading ? <Indicator dark style={styles.absView}/> : null}
        {showSetupInvestAccountInInvestScreens ? <SetupInvestmentAccountButton brand floating/> : null}
        {fundPickerMode ? <FundPickerFloatingBar popCount={2}/> : null}
      </AppView>);
}, ({ colors }) => ({
    hasCustomTitle: true,
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styles = StyleSheet.create({
    absView: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'absolute',
    },
});
export default CategoryFilterDetailsScreen;
